import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { ImageDeliverableService } from '../shared/image-deliverable/image-deliverable.service';
import { CustomComponent } from './custom.component';

@Injectable({ providedIn: 'root' })
export class CustomService {
  private readonly imageDeliverableService = inject(ImageDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.imageDeliverableService.getConfig({
      component: CustomComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.customDeliverable.title',
      deliverableType: EDeliverableType.custom,
    });
  }
}
